export const VisitGeneratorErrorCodes = {
  VISIT_GENERATOR_FAILURE: 'VISIT_GENERATOR_FAILURE',
  MISSING_PATIENT_INFO: 'MISSING_PATIENT_INFO',
  NO_ACTIVE_SCHEDULE: 'NO_ACTIVE_SCHEDULE',
  DAY_ONE_INFORMATION_MISSING: 'DAY_ONE_INFORMATION_MISSING',
} as const;

export type VisitGeneratorErrorCode = (typeof VisitGeneratorErrorCodes)[keyof typeof VisitGeneratorErrorCodes];
